//Document ready
$(function() {
	eshopSliderInit();
});

//EshopIntroSlider init
function eshopSliderInit() {
    if($('.eshop-intro-slider').length) {
        $('.eshop-intro-slider').slick({
            asNavFor: '.eshop-intro-pagination'
        });
        $('.eshop-intro-pagination').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.eshop-intro-slider',
            focusOnSelect: true
        });
    }
}